import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Seo from './Seo';
import ProductSidebar from './ProductSidebar';
import { useUser, studioThemeClass } from '../contexts/UserContext';
import ResumeBuilderStudio from './ResumeBuilderStudio';
import './ResumeBuilderLanding.css';

const ResumeStudioPage = () => {
  const navigate = useNavigate();
  // Theme lives in UserContext so every studio shares one switch — see
  // STUDIO_THEMES there.
  const { user, studioTheme } = useUser();

  // Auth modal lives on the homepage; route there with a flag when needed.
  const setShowAuthModal = useCallback((show) => {
    if (show) navigate('/?openLogin=1');
  }, [navigate]);

  return (
    // `rbl-page` supplies the shared design tokens; the theme class flips
    // this one route's surface (see ResumeBuilderStudio.theme.css). Don't
    // restyle `rbl-page` itself — the resume landing page uses it too.
    <div className={`rbl-page cls-page ${studioThemeClass(studioTheme)}`}>
      <Seo
        title="Resume Studio — Build Your ATS-Ready Resume"
        description="Edit on the left, watch your resume render live on the right, and export a clean ATS-ready DOCX in minutes."
        path="/resume-studio"
      />
      <Header setShowAuthModal={setShowAuthModal} />
      <ProductSidebar user={user} setShowAuthModal={setShowAuthModal} />

      <ResumeBuilderStudio setShowAuthModal={setShowAuthModal} />
    </div>
  );
};

export default ResumeStudioPage;
